import { CheckGateOptions } from "./types";

/**
 * Registry of all feature gates used in the application.
 * To add a new gate, simply add an entry to this map.
 */
export const GATES = {
  ENABLE_MODELING_LABS: {
    gateName: "enable_modeling_labs",
    fallback: true,
  },
  ENABLE_LEARNING_LABS: {
    gateName: "enable_learning_labs",
    fallback: true,
  },
  ENABLE_GRADED_LABS: {
    gateName: "enable_graded_labs",
    fallback: true,
  },
  ENABLE_STANDALONE_LABS: {
    gateName: "enable_standalone_labs",
    fallback: false,
  },
  ENABLE_PRACTICE_LABS: {
    gateName: "enable_practice_labs",
    fallback: false,
  },
  GET_ACCESS_FROM_ORDERS: {
    gateName: "get_access_from_orders",
    fallback: false,
  },
  ENABLE_SCORM_CONTENT: {
    gateName: "enable_scorm_content",
    fallback: false,
  },
  ENABLE_STORE_PROMOTIONS: {
    gateName: "enable_store_promotions",
    fallback: true,
  },
  ENABLE_GRADED_LABS_RETIRING: {
    gateName: "enable_graded_labs_retiring",
    fallback: false,
  },
  FILTERS_COLLAPSED_BY_DEFAULT: {
    gateName: "filters_collapsed_by_default",
    fallback: true,
  },
  ENABLE_DURATION_FILTER: {
    gateName: "enable_duration_filter",
    fallback: true,
  },
  ENABLE_COLLECTIONS_RETRIEVAL: {
    gateName: "enable_collections_retrieval",
    fallback: true,
  },
  ENABLE_EXAM_TOPICS_BLADE: {
    gateName: "enable_exam_topics_blade",
    fallback: true,
  },
  ENABLE_ILT_BLADE: {
    gateName: "enable_ilt_blade",
    fallback: true,
  },
  EMAIL_NOTIFICATION_OPT_IN: {
    gateName: "email_communication_opt_in",
    fallback: true,
  },
  ENABLE_MINDTICKLE_EXTERNAL_LAUNCH: {
    gateName: "enable_mindtickle_external_launch",
    fallback: false,
  },
  ENABLE_RENEWAL_ORDERS: {
    gateName: "enable_renewal_orders",
    fallback: false,
  },
  ENABLE_AI_LEARNING_EXPERIENCE: {
    gateName: "enable_ai_learning_experience",
    fallback: false,
  },
  ENABLE_MY_CERTIFICATIONS: {
    gateName: "enable_my_certifications",
    fallback: false,
  },
  ENABLE_REV_UP_RECERT: {
    gateName: "enable_rev_up_recert",
    fallback: false,
  },
  ENABLE_LTI_PROVISIONING_SPLASH: {
    gateName: "enable_lti_provisioning_splash",
    fallback: false,
  },
  ENABLE_SJC_OUTAGE: {
    gateName: "enable_sjc_outage",
    fallback: false,
  },
} as const satisfies Record<string, CheckGateOptions>;

export type GateKey = keyof typeof GATES;
